<template>
    <DnCheckbox
        class="base-checkbox"
    >
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>
    </DnCheckbox>
</template>

<script setup>
import DnCheckbox from '@digitalnatives/checkbox';
</script>

<style lang="less">
.base-checkbox.dn-checkbox {
    --checkbox-accent-color: var(--color-darkest);

    .dn-checkbox__label {
        margin-left: .5rem;
        font-size: .875rem;
    }

    .dn-checkbox__custom {
        position: relative;

        width: 1rem;
        height: 1rem;

        background: transparent;
        border: 1px solid currentColor;
        border-radius: 2px;

        // Checked styles
        &:after {
            content: '';
            line-height: 1;

            position: absolute;
            top: 0;
            left: 0%;
            width: 100%;
            height: 100%;
            transform: none;
            transition: all 150ms 0ms linear;

            display: block;
            background-image: url('assets/img/icons/check.svg');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            background-color: var(--checkbox-accent-color);
            opacity: 0;
            color: var(--color-primary);
        }
    }
}
</style>
